import $ from 'jquery';

export default function () {
  /// /// Text-Switcher ////
  // Function to switch Text of $this.Element and Toggle .next().sibling
  // Beispiel: Button: Öffnen/Schliessen mit nachfolgendem Formular

  function clickTextSwitcher (target, child, slider) {
    $(target).click(function () {
      if (slider) {
        $(this).parent().find(child).slideToggle(200);
      }
      $(this).html($(this).html() === $(this).data('open') ? $(this).data('close') : $(this).data('open'));
    });
  }

  clickTextSwitcher('#formular_oeffnen', '.newsletter-form', true);
}
